<template>
  <export-to-platform
    v-bind="$attrs"
    platform="canvas"
    :disabled="false"
    :available-options="availableOptions"
    :additional-options="additionalOptions"
    :selected-options="selectedOptions"
    @update:selected-options="updateSelectedOptions"
    @essays-exported="$emit('essays-exported')"
  >
    <template #reAuth="{ cancel, resolve }">
      <CanvasInstruction @updated="resolve">
        <template #cancel-button>
          <eg-b-button class="mr-3" @click="cancel">{{
            $t("common.cancel")
          }}</eg-b-button>
        </template>
      </CanvasInstruction>
    </template>
  </export-to-platform>
</template>

<script>
import CanvasInstruction from "@/components/imports/canvas/canvas_instruction.vue";
import ExportToPlatform from "./export_to_platform";
import i18n from "@/i18n/i18n";
const defaultAvailableOptions = [
  "content",
  "feedback",
  "errors",
  "comments",
  "exportGrades",
];

export default {
  name: "ExportToCanvasModal",

  components: {
    CanvasInstruction,
    ExportToPlatform,
  },

  data() {
    return {
      selectedOptions: [...defaultAvailableOptions],
      availableOptions: [...defaultAvailableOptions],
      additionalOptions: [
        {
          label: i18n.t("essays.export.grades"),
          description: i18n.t("essays.export.assignedInCanvas"),
          descriptionClass: "small-text text-secondary",
          value: "exportGrades",
        },
        {
          text: i18n.t("essays.export.hideGrades"),
          value: "hideGrades",
        },
      ],
    };
  },

  methods: {
    updateSelectedOptions(newSelectedOptions) {
      this.selectedOptions = newSelectedOptions;

      if (
        !this.selectedOptions.includes("exportGrades") &&
        !this.availableOptions.includes("hideGrades")
      ) {
        this.availableOptions = [...defaultAvailableOptions, "hideGrades"];
        this.selectedOptions = [
          ...new Set([...this.selectedOptions, "hideGrades"]),
        ];
      }

      if (this.selectedOptions.includes("exportGrades")) {
        this.availableOptions = [...defaultAvailableOptions];

        this.selectedOptions = this.selectedOptions.filter(
          (option) => option !== "hideGrades"
        );
      }
    },
  },
};
</script>
